import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=9e6b906c&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=9e6b906c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6b906c",
  null
  
)

export default component.exports